import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import ChatIntentList from '../../../components/ChatIntent/List';
import UpdateChatIntentModal from '../../../components/ChatIntent/Update/UpdateChatIntent';

@inject('chatIntentStore')
@observer
class ChatIntentPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.chatIntentStore.initChatIntent();
    }

    componentWillUnmount() {
        this.props.chatIntentStore.setShowUpdateChatIntentModal(false);
    }

    handleCancelUpdateChatIntentModal = () => {
        this.props.chatIntentStore.setShowUpdateChatIntentModal(false);
    }

    handleCancelSearchMenuIteModal = () => {
        this.props.chatIntentStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const { 
            showUpdateChatIntentModal, 
            manageChatIntentTitle
        } = this.props.chatIntentStore;

        return (
            <MainContainer title='Chat Intent Management' menukey='chatintent'>
                <Modal
                    title={manageChatIntentTitle}
                    visible={showUpdateChatIntentModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelUpdateChatIntentModal}
                    zIndex={1000}
                >
                    <UpdateChatIntentModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <ChatIntentList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default ChatIntentPage
